import { render, staticRenderFns } from "./StockTransfer.vue?vue&type=template&id=59c993b0"
import script from "./StockTransfer.vue?vue&type=script&lang=js"
export * from "./StockTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports